<!--
 * @Descripttion: 任务记录管理
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="task-record-list">
    <BaseAuditStatusSelect
      v-if="isAsp && projectType !== 6"
      :key="auditStatusSelectKey"
      @change-status="onChangeAuditStatus"
      :statusMap="statusMap"
      :defaultValue="auditStatusSelectDefaultValue"
    ></BaseAuditStatusSelect>
    <div
      v-if="isAsp && projectType !== 6"
      style="margin: 10px 0; height: 1px; width: 100%; background: #e5e5e5"
    ></div>
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    >
      <template #tableBefore>
        <div
          v-if="isAsp"
          v-show="ajaxProjectInfo.projectRequire && showProjectRequire"
        >
          <div style="">
            <div class="xrk-alert xrk-alert--warning is-light" role="alert">
              <i class="xrk-icon xrk-alert__icon is-big">
                <BaseIcon class="contract" color="#ff5252">
                  <WarningFilled />
                </BaseIcon>
              </i>
              <div class="xrk-alert__content">
                <span
                  class="xrk-alert__title with-description"
                  style="color: #ff5252"
                >
                  审核要求
                </span>
                <p class="xrk-alert__description" style="color: #ff5252">
                  {{ ajaxProjectInfo.projectRequire }}
                </p>
                <i
                  @click="onGetAuditRequire(false)"
                  class="xrk-icon xrk-alert__close-btn"
                >
                  <BaseIcon style="color: #898989" size="16">
                    <Close />
                  </BaseIcon>
                </i>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            margin: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div v-if="isAsp">
            <base-checkbox
              :indeterminate="isIndeterminate"
              v-model="isSelectionAll"
              @change="onSelectionAllChange"
            ></base-checkbox>

            <span style="margin-right: 5px" class="title">结果全选</span>
            <span class="title">
              已选{{ selectionRows.length }}条，批量操作
            </span>
            <base-button
              v-if="canAudit"
              v-resource="['任务记录_审核任务']"
              style="margin-left: 10px"
              type="default"
              @click="onBatchAudit(2)"
            >
              通过
            </base-button>
            <base-button
              v-if="canAudit"
              v-resource="['任务记录_审核任务']"
              type="default"
              @click="onBatchAudit(3)"
            >
              不通过
            </base-button>
            <base-button
              v-resource="['任务记录_任务过期']"
              type="default"
              @click="taskExpire()"
            >
              任务过期
            </base-button>
            <base-button
              v-if="showProjectRequireBtn"
              type="default"
              @click="onGetAuditRequire"
            >
              查看审核要求
            </base-button>

            <!-- 智能辅助审核 · 待审核分解统计 -->
            <!-- 智能结果不准确，产品让隐藏 -->
            <!-- <span v-if="showAITip && isShowAi" class="si-card-ai">
              智能辅助审核
              <span class="e">审核失败 {{ aiStats.fail }}</span>
              ·
              <span class="g">建议通过 {{ aiStats.pass }}</span>
              ·
              <span class="o">建议存疑 {{ aiStats.suspect }}</span>
              ·
              <span class="r">建议驳回 {{ aiStats.reject }}</span>
            </span> -->
          </div>
          <div v-if="isAsp" style="display: flex">
            <div style="margin-right: 5px">
              <base-button
                v-if="['2,1'].includes(isEntry)"
                type="default"
                @click="onAddTaskNum()"
              >
                添加任务量
              </base-button>
              <base-button
                v-if="['2,1', '2,2'].includes(isEntry)"
                type="default"
                @click="onImportSettlementAmount()"
              >
                导入结算金额
              </base-button>
            </div>
            <div
              v-if="canAudit && projectType !== 19"
              style="display: flex; align-items: center"
            >
              <div
                style="
                  line-height: 32px;
                  font-size: 14px;
                  margin-right: 5px;
                  font-size: 14px;
                  color: #121619;
                  line-height: 22px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                "
              >
                是否允许超量审核
              </div>
              <BaseSwitch
                :active-value="1"
                :inactive-value="0"
                :active-text="excessiAudit ? '允许' : '不允许'"
                v-model="excessiAudit"
                @change="onChangeExcessiAudit"
              ></BaseSwitch>
            </div>
          </div>
        </div>
        <div v-if="isAsp && hasRepeatPic">
          <div style="display: flex; align-items: center; margin-bottom: 6px">
            <span style="color: rgb(220 56 34)">提示：*标记为</span>
            <img
              style="width: 20px; height: 20px; margin: 0 3px"
              src="https://oss.myxrk.com/myxrk-v2/front-end/assets/oss/icon/2509011532.png"
            />
            <span style="color: rgb(220 56 34)">
              任务存在提交的图片存在重复，请注意查看
            </span>
          </div>
        </div>
      </template>
    </xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed, watch, onBeforeMount } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';

import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton,
  XrkTableRef,
  BaseSwitch,
  BaseCheckbox,
  createDialog,
  useCreateModal,
  XrkMessage,
  BaseDatePicker,
  useSelectColumn,
  BaseIcon
} from 'xrk-components';
import { WarningFilled, Close } from '@element-plus/icons-vue';

import SetDisplayInfo from './set-display-info.vue';
import AddTaskNumList from './add-task-num-list.vue';
import BaseAuditStatusSelect from '@/components/biz/biz-status-select/index';
import ImportSettlementAmount from './import-settlement-amount.vue';

import { searchByProjectType } from '../fields/searchs';
import { columnsByProjectType } from '../fields/columns';

// 智能辅助审核增量字段（AI 结果搜索 + 列 + 统计卡）
import {
  aiResultSearch,
  aiResultCol,
  taskRiskPointsCol
} from '@/common/fields/intelligent-audit';

import {
  taskRecordList,
  setExcessAudit,
  addTaskNumAjax,
  downloadTask,
  taskRecordStats,
  getProjectInfo,
  getOverdue,
  batchOverdue,
  getTaskRecordIds,
  submitTask,
  selectSimilartList,
  exportTaskRecordList,
  colShow
} from '../data-source/apis';

import { ProjectType } from '../types';
import { useTaskAudit, useOpenTaskDetail } from '../hooks/useTaskAudit';
import { MAX_SELECT_LENGTH } from '../constants/index';
import OperationRecord from '../components/operation-record.vue';
import RepeatPickure from './repeat-pickure.vue';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { getUnqualifiedRowConfig } from '@/utils/unqualified';
import { IS_ASSISTANT } from '@/config';

import appStore from '@/store';

const router = useRouter();
const route = useRoute();

// 工业-1 服务商-2 供应商-3
const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);

/**
 * 是否是服务商
 */
const isAsp = computed(() => defaultUserFnCode.value === 2);

const auditStatusSelectDefaultValue = ref(route.query.activityName ? null : 0);
const auditStatusSelectKey = ref(0);

const xrkTableRef = ref<XrkTableRef>();

const excessiAudit = ref(0);
const tableDataRow = ref([]); //当前搜索条件下可勾选的id
const isSelectionAll = ref(false);

const refreshTableRender = ref(0);

type Item = { label: string; value: number; num: number };
const statusMap = ref<Item[]>(null); // 审核状态+条数

// 智能辅助审核分解统计；统计卡只在"待审核"(value=0)筛选下显示
const aiStats = ref({ fail: 0, pass: 0, suspect: 0, reject: 0 });

// 勾选列表数据
const selectionRows = computed(() => {
  return xrkTableRef.value?.getSelectionRows() || [];
});
const isIndeterminate = computed(() => {
  if (selectionRows.value.length === 0) {
    return false;
  }
  return selectionRows.value.length !== tableDataRow.value.length;
});
const onSelectionAllChange = (val: boolean) => {
  if (val) {
    tableDataRow.value.forEach(item => {
      xrkTableRef.value.addSelectionRow(item, {
        [projectType.value === 6 ? 'userId' : 'id']: item
      });
    });
  } else {
    xrkTableRef.value.clearSelectionRows();
  }
  isSelectionAll.value = val;
};

// 勾选列表数据变化时，更新全选状态
watch(
  () => selectionRows.value,
  val => {
    if (val.length === 0) {
      isSelectionAll.value = false;
      return;
    }
    isSelectionAll.value = val.length === tableDataRow.value.length;
  }
);
const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);
// store.setBaseData({
//   ...store.baseData,
//   projectInfo: {
//     ...projectInfo.value,
//     id: 7,
//     sceneType: 19
//   }
// });
const projectType = computed<ProjectType>(() => {
  return projectInfo.value.sceneType;
});

const projectId = computed<number>(() => {
  return projectInfo.value.id;
});

//协定服务上传来源1ASP上传2C端上传3双方共同上传
const agreementServiceUploadType = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadType;
});

//协定服务上传方式1以活动方式上传2以人为维度上传
const agreementServiceUploadMode = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadMode;
});

const isEntry = [
  +agreementServiceUploadMode.value,
  +agreementServiceUploadType.value
].join(',');
// '1,3': '活动形式-双方共同上传',
// '1,1': '活动形式-服务商上传',
// '2,2': '人为维度-终端上传',
// '2,1': '人为维度-服务商上传',
const canAudit = computed(() => {
  return (
    [21, 17, 5, 20].includes(projectType.value) ||
    ['1,3', '2,2'].includes(isEntry)
  );
});

const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
};
const onChangeExcessiAudit = () => {
  setExcessAudit({
    projectId: projectId.value,
    sceneType: projectType.value,
    excessAudit: excessiAudit.value
  }).then(() => {
    onRefreshTabel();
  });
};
/**
 * 批量审核
 * @param status 审核状态
 */
const onBatchAudit = status => {
  useTaskAudit({
    auditStatus: status,
    projectId: projectId.value,
    isBatch: true,
    queryParams: {
      sceneType: projectType.value,
      taskRecordId: selectionRows.value.map(item => item.id)
    },
    auditOver() {
      xrkTableRef.value.clearSelectionRows();
      onRefreshTabel();
    }
  });
};

const ajaxProjectInfo = ref<{ projectRequire: string }>({
  projectRequire: ''
});

const showProjectRequire = ref(false);
const showProjectRequireBtn = computed(() => {
  return !!ajaxProjectInfo.value.projectRequire;
});
const isSetTime = ref(0);
const onGetAjaxProjectInfo = async () => {
  const { data: projectInfo } = await getProjectInfo({
    projectId: projectId.value
  });
  ajaxProjectInfo.value = projectInfo;
  isSetTime.value = projectInfo.setTime;
  showProjectRequire.value = !!ajaxProjectInfo.value.projectRequire;
};
onGetAjaxProjectInfo();

const onGetAuditRequire = e => {
  showProjectRequire.value = e;
};

const onAddTaskNum = () => {
  const addTaskNumListRef = ref();
  createDialog({
    title: '添加任务量',
    width: 800,
    confirmBtnConfig: {
      content: '确认添加'
    },
    contentRender: () => {
      return (
        <div style="padding: 20px">
          <AddTaskNumList ref={addTaskNumListRef} projectId={projectId.value} />
        </div>
      );
    },
    async beforeConfirm() {
      const data = addTaskNumListRef.value.getSelectData();
      await addTaskNumAjax({ taskNumVOList: data });
      onRefreshTabel();
    }
  });
};

/**
 * 导入结算金额
 */
const onImportSettlementAmount = () => {
  useCreateModal(ImportSettlementAmount, {
    onDownLoadTaskList() {
      const searchVal = xrkTableRef.value.getSearchValue();
      const [editStatusAtStart, editStatusAtEnd] = searchVal.editStatusAt || [
        '',
        ''
      ];
      const [visitDtStart, visitDtEnd] = searchVal.visitDt || ['', ''];
      const generalAuditStatus =
        searchVal.generalAuditStatus === (isAsp.value && undefined)
          ? [0]
          : searchVal.generalAuditStatus;

      const reqData = {
        ...searchVal,
        sceneType: projectType.value,
        projectId: projectId.value,
        editStatusAtStart,
        editStatusAtEnd,
        visitDtStart,
        visitDtEnd,
        generalAuditStatus
      };
      downloadTask(reqData);
    },
    onRefreshTabel() {
      onRefreshTabel();
    }
  });
};

/**
 * 任务过期
 */
const taskExpire = async () => {
  if (!selectionRows.value.length) {
    XrkMessage.error('请选择需要过期的任务');
    return;
  }
  const countdownRef = ref(3);
  const timer = setInterval(() => {
    countdownRef.value--;
    if (countdownRef.value <= 0) {
      clearInterval(timer);
    }
  }, 1000);

  const overdueDate = ref([]); //过期时间 数字专区用

  const overdueIds = ref([]); //后端筛选出的可以过期的id

  const getOverdueIds = async () => {
    const params = {
      projectId: projectId.value,
      sceneType: projectType.value,
      taskRecordId: selectionRows.value.map(item => item.id),
      userId: selectionRows.value.map(item => item.userId),
      createAtStart: overdueDate.value.length ? overdueDate.value[0] : '',
      createAtEnd: overdueDate.value.length ? overdueDate.value[1] : ''
    };
    if (projectType.value === 6) {
      delete params.taskRecordId;
    } else {
      delete params.userId;
    }
    const { data } = await getOverdue(params);
    if (!data || !data.length) {
      XrkMessage.error('没有可以过期的任务');
      return;
    }
    overdueIds.value = data;
  };

  const footerRender = done => {
    return (
      <div>
        <BaseButton
          type="default"
          onClick={() => {
            clearInterval(timer);
            done();
          }}
        >
          取消
        </BaseButton>
        <BaseButton
          type="primary"
          disabled={countdownRef.value > 0}
          onClick={async () => {
            if (!overdueDate.value && projectType.value === 6) {
              XrkMessage.error('请选择过期时间');
              return;
            }
            const params = {
              projectId: projectId.value,
              sceneType: projectType.value,
              taskRecordId: overdueIds.value,
              createAtStart: overdueDate.value.length
                ? overdueDate.value[0]
                : '',
              createAtEnd: overdueDate.value.length ? overdueDate.value[1] : ''
            };
            await batchOverdue(params);
            XrkMessage.success('操作成功');
            clearInterval(timer);
            done();
            onRefreshTabel();
            xrkTableRef.value.clearSelectionRows();
          }}
        >
          {countdownRef.value > 0 ? countdownRef.value + 's' : '确定'}
        </BaseButton>
      </div>
    );
  };

  if (projectType.value === 6) {
    createDialog({
      width: 350,
      title: '提示',
      showClose: true,
      closeOnPressEscape: true,
      contentRender() {
        return (
          <>
            <div style="padding: 20px">
              <div>选择过期时间</div>
              <BaseDatePicker
                type="daterange"
                style="width: 100%"
                v-model={overdueDate.value}
                onChange={async () => {
                  await getOverdueIds();
                }}
              ></BaseDatePicker>
              {overdueIds.value.length > 0 && (
                <span style="margin-top: 10px">{`您确定将 ${overdueIds.value.length} 条任务标记为过期吗，此操作不可撤回`}</span>
              )}
            </div>
          </>
        );
      },
      footerRender,
      onClose() {
        clearInterval(timer);
      }
    });
    return;
  }
  await getOverdueIds();
  overdueIds.value.length > 0 &&
    createDialog({
      width: 350,
      title: '提示',
      showClose: true,
      closeOnPressEscape: true,
      content: `您确定将 ${overdueIds.value.length} 条任务标记为过期吗，此操作不可撤回`,
      footerRender,
      onClose() {
        clearInterval(timer);
      }
    });
};

// 展示审核不通过企业类型
const showAITip = ref(false);
const isColShow = ref(false);
onBeforeMount(async () => {
  const res = await colShow({ projectId: projectId.value });
  isColShow.value = Boolean(res.data);
});
const isShowAi = computed(() => {
  return isAsp.value && isColShow.value && ![6, 19].includes(projectType.value);
});

const onChangeAuditStatus = (val: any[]) => {
  showAITip.value = !val?.length || val.includes(0) || val.includes(null);

  const _val = val.filter(item => item !== null);
  xrkTableRef.value?.setSearchValue(
    'generalAuditStatus',
    _val.length ? _val : null
  );
  onRefreshTabel();
  xrkTableRef?.value?.clearSelectionRows();
};

//不展示快捷审核
const dontShowAuickAudit = computed(() => {
  return [6, 19, 21].includes(projectType.value) || !isAsp.value;
});

//是否是个体
const isGeti = computed(() => {
  return projectInfo.value.ctype === 3;
});

// 展示审核不通过企业类型
const showReject = computed(() => {
  return xrkTableRef.value?.getSearchValue().generalAuditStatus?.includes(3);
});

// 搜索项
const searchConfig = computed<XrkTableProps['searchConfig']>(() => {
  return {
    searchBtn: {
      show: true,
      text: '搜索'
    },
    resetBtn: {
      show: true,
      text: '重置',
      beforeReset() {
        auditStatusSelectKey.value++;
        auditStatusSelectDefaultValue.value = 0;
      }
    },
    searchColumns: [
      ...searchByProjectType(
        projectType.value,
        isEntry,
        isGeti.value,
        isSetTime.value
      ),
      showReject.value &&
        useSelectColumn({
          prop: 'rejectAuditPlatform',
          label: '审核不通过企业类型',
          config: {
            placeholder: '请选择',
            options: {
              0: { label: '平台方', value: 0 },
              1: { label: '服务商', value: 1 }
            },
            clearable: true
          }
        }),
      isShowAi.value && aiResultSearch
    ].filter(Boolean),
    otherComponents: [
      {
        render() {
          return (
            <>
              {projectType.value !== 6 && (
                <BaseButton
                  v-resource={[['任务记录_导出']]}
                  type="primary2"
                  click={async () => {
                    if (pageTableData.value.length === 0) {
                      XrkMessage.error('当前列表暂无数据，暂无法导出哦～');
                      return;
                    }
                    await exportTaskRecordList(searchParams.value);
                    XrkMessage.success('下载成功，请前往下载中心查看');
                  }}
                >
                  导出
                </BaseButton>
              )}

              {!dontShowAuickAudit.value && (
                <BaseButton
                  v-resource={[['任务记录_审核任务']]}
                  type="primary2"
                  onClick={() => {
                    useCreateModal(SetDisplayInfo, {
                      projectId: projectId.value,
                      projectType: projectType.value,
                      onConfirm() {
                        router.push({
                          path: '/main/asp/task-mgmt-list/quick-list',
                          query: {
                            projectId: projectId.value,
                            projectType: projectType.value
                          }
                        });
                      }
                    });
                  }}
                >
                  快捷审核
                </BaseButton>
              )}
            </>
          );
        }
      }
    ]
  };
});

/**
 * 查看任务详情
 * @param id
 */
const onTaskDetail = async (id: number, dataState: number) => {
  useOpenTaskDetail({
    id,
    dataState,
    projectType: projectType.value,
    projectId: projectId.value,
    canAudit: canAudit.value,
    xrkTableRef
  });
};

const repeatPickurePerview = (row, similarTaskIdList) => {
  createDialog({
    width: 1500,
    title: '图片重复关联项目',
    showClose: true,
    contentRender: () => {
      return (
        <div style="padding: 20px;">
          <RepeatPickure
            projectId={projectId.value}
            taskId={row.id}
            similarTaskIdList={similarTaskIdList}
          ></RepeatPickure>
        </div>
      );
    },
    beforeConfirm: async done => {
      done();
    }
  });
};
// 列表
const tableConfig = computed<XrkTableProps['tableConfig']>(() => {
  return {
    tableColumns: [
      isAsp.value &&
        useTableColumn({
          type: '_selection',
          prop: projectType.value === 6 ? 'userId' : 'id',
          align: 'center',
          fixed: 'left',
          width: 60,
          selectionDisabled(row) {
            if (projectType.value === 6) {
              //数字专区不审核此勾选为任务过期
              return false;
            }
            return (
              row.superviseStatus !== 1 ||
              row.isOverdue === 1 || //已过期
              row.dataState === 2 || //已结算
              row.settlementCount > 0 || //已结算任务量
              row.overdueCount > 0 || //过期任务量
              row.platformAuditStatus === 1 //平台审核中
            );
          }
        }),
      useTableColumn({
        type: 'index',
        label: '序号',
        width: '65px',
        fixed: 'left',
        render: ({ row, index }) => {
          const hasRepeatPicIds = Object.keys(repitImgList.value);
          const isHasRepeatPic = hasRepeatPicIds.includes(String(row.id));
          return (
            <div>
              {isHasRepeatPic && (
                <img
                  src="https://oss.myxrk.com/myxrk-v2/front-end/assets/oss/icon/2509011532.png"
                  style="cursor:pointer;width:20px;"
                  onClick={() => {
                    repeatPickurePerview(row, repitImgList.value[row.id]);
                  }}
                  type="text"
                />
              )}
              <span>{index + 1}</span>
            </div>
          );
        }
      }),
      ...columnsByProjectType(
        projectType.value,
        isEntry,
        xrkTableRef,
        defaultUserFnCode.value,
        isGeti.value,
        isSetTime.value
      ),
      isShowAi.value && aiResultCol,
      isShowAi.value && taskRiskPointsCol,
      useTableColumn({
        align: 'center',
        fixed: 'right',
        label: '操作',
        width: 230,
        render({ row }) {
          return (
            <>
              <div>
                <BaseButton
                  style="margin-right: 12px"
                  onClick={async () => {
                    onTaskDetail(row.id, row.dataState);
                  }}
                  type="text"
                >
                  查看
                </BaseButton>
                {isAsp.value && (
                  <div style="display:inline-block">
                    {canAudit.value && (
                      <>
                        <BaseButton
                          v-resource={[['任务记录_审核任务']]}
                          disabled={
                            row.buttonOnOff === 0 || row.buttonOnOff === 2
                          }
                          onClick={() => {
                            useTaskAudit({
                              auditStatus: 2,
                              projectId: projectId.value,
                              queryParams: {
                                sceneType: projectType.value,
                                taskRecordId: [row.id]
                              },
                              auditOver() {
                                xrkTableRef.value.clearSelectionRows();
                                onRefreshTabel();
                              }
                            });
                          }}
                          type="text"
                        >
                          通过
                        </BaseButton>
                        <BaseButton
                          v-resource={[['任务记录_审核任务']]}
                          disabled={row.buttonOnOff === 0}
                          onClick={() => {
                            useTaskAudit({
                              auditStatus: 3,
                              projectId: projectId.value,
                              queryParams: {
                                sceneType: projectType.value,
                                taskRecordId: [row.id]
                              },
                              auditOver() {
                                xrkTableRef.value.clearSelectionRows();
                                onRefreshTabel();
                              }
                            });
                          }}
                          type="text"
                        >
                          不通过
                        </BaseButton>
                      </>
                    )}
                    {projectType.value === 19 &&
                      !['2,2', '1,3'].includes(isEntry) && (
                        <BaseButton
                          v-resource={[['任务记录_审核任务']]}
                          disabled={
                            row.fileStatus === 0 ||
                            !row.price ||
                            row.platformAuditStatus === 1 ||
                            row.platformAuditStatus === 2 ||
                            row.isOverdue === 1
                          }
                          onClick={async () => {
                            await submitTask({
                              taskRecordId: row.id,
                              projectId: projectId.value
                            });
                            onRefreshTabel();
                          }}
                          type="text"
                        >
                          提交
                        </BaseButton>
                      )}
                    <BaseButton
                      v-resource={[['任务记录_审核任务']]}
                      onClick={async () => {
                        createDialog({
                          width: 850,
                          title: '操作记录',
                          showClose: true,
                          closeOnPressEscape: true,
                          contentRender: () => {
                            return (
                              <div style="padding: 20px;">
                                <OperationRecord
                                  taskRecordId={row.id}
                                ></OperationRecord>
                              </div>
                            );
                          },
                          beforeConfirm: async done => {
                            done();
                          }
                        });
                      }}
                      type="text"
                    >
                      操作记录
                    </BaseButton>
                  </div>
                )}
              </div>
            </>
          );
        }
      })
    ].filter(Boolean),
    baseConfig: {
      resizable: true,
      rowKey: projectType.value === 6 ? 'userId' : 'id',
      rowClassName({ row, rowIndex }) {
        const isUnqualified = () => {
          if (row?.isOverdue === 1 || row?.dataState === 2) {
            return true;
          }
          return row?.superviseStatus === 1;
        };
        return getUnqualifiedRowConfig({
          row: row,
          rowIndex: rowIndex,
          isNotUnqualified: isUnqualified()
        });
      },
      onSortChange: data => {
        let prop = String(data.prop); // 显式转换为字符串
        const order = String(data.order) === 'null' ? '' : String(data.order); // 显式转换为字符串

        if (prop === 'editStatusAt') {
          prop = 'finishDt';
        }

        xrkTableRef.value.setSearchValue(`${prop}Order`, order);
        xrkTableRef.value.initCurrentList();
      },
      onSelect(selection: any, row: any) {
        if (selection.length > MAX_SELECT_LENGTH) {
          XrkMessage.warning('最多只能选择' + MAX_SELECT_LENGTH + '条数据');
          xrkTableRef.value.removeSelectionRow(row.id);
        }
      },
      onSelectAll(selection) {
        if (selection.length > MAX_SELECT_LENGTH) {
          // 获取selection超过MAX_SELECT_LENGTH个的时候，清除多余的selection
          XrkMessage.warning('最多只能选择' + MAX_SELECT_LENGTH + '条数据');
          selection.slice(MAX_SELECT_LENGTH).forEach((item: any) => {
            xrkTableRef.value.removeSelectionRow(item.id);
          });
        }
      }
    }
  };
});

const getRecordStatsAjax = async params => {
  const { data } = await taskRecordStats(params);
  statusMap.value = [
    {
      label: '全部',
      value: null,
      num:
        data.supplierPending +
        data.platformPending +
        data.approved +
        data.rejected
    },
    {
      label:
        projectType.value === 19 && !['2,2', '1,3'].includes(isEntry)
          ? '待提交'
          : '待审核',
      value: 0,
      num: data.supplierPending
    },
    !IS_ASSISTANT && {
      label: '待平台审核',
      value: 1,
      num: data.platformPending
    },
    {
      label: '审核通过',
      value: 2,
      num: data.approved
    },
    {
      label: '审核未通过',
      value: 3,
      num: data.rejected
    }
  ].filter(Boolean) as Item[];
  const s = data.aiOssStats;
  aiStats.value = {
    fail: s?.aiOssFailCount ?? 0,
    pass: s?.aiOssPassCount ?? 0,
    suspect: s?.aiOssDoubtCount ?? 0,
    reject: s?.aiOssRejectCount ?? 0
  };
  const { data: projectInfo } = await getProjectInfo({
    projectId: projectId.value
  });
  excessiAudit.value = projectInfo.isExcessAudit;
};
const pageTableData = ref([]); // 当前列表数据

// 重复图片列表
const repitImgList = ref({});

const hasRepeatPic = computed(() => {
  // 当前是否有重复图片
  return Object.keys(repitImgList.value).length > 0;
});
const getRepitImgList = async () => {
  const { data } = await selectSimilartList({
    projectId: projectId.value,
    taskIdList: pageTableData.value.map(i => i.id)
  });
  repitImgList.value = data || {};
  refreshTableRender.value++;
};

// 获取当前搜索条件下可勾选的id集合
const getRecordIds = async params => {
  const { data } = await getTaskRecordIds(params, 'task');
  tableDataRow.value = data || [];
};

const searchParams = ref({});

const getListAjax = async params => {
  const [editStatusAtStart, editStatusAtEnd] = params.editStatusAt || ['', ''];
  const [visitDtStart, visitDtEnd] = params.visitDt || ['', ''];

  // 上方状态选择框的搜索值
  let generalAuditStatus =
    params.generalAuditStatus === (isAsp.value && undefined)
      ? [auditStatusSelectDefaultValue.value]
      : params.generalAuditStatus;

  if (projectType.value === 6) generalAuditStatus = null;
  generalAuditStatus =
    generalAuditStatus?.length === 1 && generalAuditStatus[0] === null
      ? null
      : generalAuditStatus;

  const reqData = {
    ...params,
    rejectAuditPlatform: showReject.value ? params.rejectAuditPlatform : null,
    sceneType: projectType.value,
    projectId: projectId.value,
    editStatusAtStart,
    editStatusAtEnd,
    visitDtStart,
    visitDtEnd,
    generalAuditStatus
  };
  const data = await taskRecordList(reqData);
  searchParams.value = reqData;
  pageTableData.value = data.data.list;
  await getRecordStatsAjax({
    sceneType: projectType.value,
    projectId: projectId.value
  });
  isAsp.value && (await getRecordIds(reqData));
  isAsp.value && getRepitImgList();

  searchParams.value = reqData;
  return data;
};
</script>
<style lang="scss" scoped>
.task-record-list {
  .title {
    font-size: 14px;
    color: #878d96;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  ::v-deep {
    .xrk-table {
      .xrk-checkbox {
        width: 21px;
        margin-right: -8px;
        overflow: hidden;
      }
    }
    .xrk-button {
      &:focus-visible {
        outline: none !important;
      }
    }
  }
}

/* 智能辅助审核 · 待审核分解统计 */
.si-card-ai {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 20px;
  font-size: 14px;
  color: #303133;
  white-space: nowrap;
  vertical-align: middle;

  .e {
    color: #909399;
    margin: 0 2px;
  }
  .g {
    color: #1f9d5b;
    margin: 0 2px;
  }
  .o {
    color: #d98a00;
    margin: 0 2px;
  }
  .r {
    color: #e04848;
    margin: 0 2px;
  }
}
</style>
